import { Component, OnDestroy, Optional, Inject, Input } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiNavigation, PortalNavigationService } from '@pershing/nxi-ng-common';
import { Location } from '@angular/common';
import { NavigationConstants } from '../utils/navigation.constants';

@Component({
    selector: 'modern-theme-navigation',
    templateUrl: 'modern-theme-navigation.component.html',
    styleUrls: ['./modern-theme-navigation.component.css']
})
export class ModernThemeNavigationComponent implements OnDestroy {
    menuItems: any[];
    selectedPageId: string;
    selectedPage: any;
    navigation: NxiNavigation;
    linkUrl: string;
    ibdConfigMap: any;
    showPostLogin: boolean = true;
    showAdvisorIcon: boolean = true;
    advisorText: any;
    currentUri: string = '';

    @Input('menuItems') set menu(data: any) {
        console.log('DATA IN', data)
        if (data && data.length > 0) {
          this.menuItems = data;
          // Set menu list and selected menu for the page.
          this.navigationService.setSelectedPageMenu(this.currentUri, this.menuItems);
          this.selectedPageId = this.navigationService.getParentPageId();
        }
        console.log('MENU ITEMS OUT', this.menuItems);
    }
    constructor(
        private translationService: PershingTranslationService,
        protected navigationService: PortalNavigationService,
        @Optional() @Inject('AppSettings') appSettings: any,
        protected location: Location) {
           // this.moneyGuideProService.hideTitle.next(true);
        this.ibdConfigMap = appSettings.ibdConfigMap;
        this.linkUrl = appSettings.postLoginEquiptUrl;
        this.translationService.addTranslationFolder('@pershing/nxi-ng-modern-navigation', 'node_modules/@pershing/nxi-ng-modern-navigation/lib');
        this.currentUri = this.location.path(false);
        if (NavigationConstants.propertyMap.get(this.ibdConfigMap.IBD) && NavigationConstants.propertyMap.get(this.ibdConfigMap.IBD).get('Advisor')) {
            this.advisorText = NavigationConstants.propertyMap.get(this.ibdConfigMap.IBD).get('Advisor');
            this.showAdvisorIcon = false;
        } else {
            this.translationService.get('NXI_NAVIGATION.ADVISORHOME').subscribe(
                res => {
                    this.advisorText = res;
                });
        }
        // This we don't require as in MFE menuItems is being set from input
        // this.navigationService.getMenuConfigurations().subscribe(data => {
        //         let url = this.location.path(false);
        //         let urlArray = url.split('/');
        //         if (urlArray[2] === 'disclosure') {
        //             this.showPostLogin = false;
        //         } else {
        //             this.showPostLogin = true;
        //         }
        //         this.menuItems = data;
        //         this.selectedPageId = this.navigationService.getParentPageId();
        //     }
        // );
        this.navigationService.getParentPage().subscribe(childpage => {
            if (childpage) {
                this.selectedPageId = childpage.id;
            }
        });

    }

    handleNavigation(parentpage: any): void {
        this.navigation = new NxiNavigation();
        this.selectedPageId = parentpage.id;
        this.navigation.parentPage = parentpage;
        this.navigationService.handleNavigation(this.navigation);
    }
    handleNavigationLink(parentpage: any): void {
        if (parentpage.id === 'equipt') {
            window.location.href = this.linkUrl;
        } else if (parentpage.id === 'returntobanking') {
            window.location.href = parentpage.linkUrl;
        } else {
            window.open(parentpage.linkUrl);
        }
        return;
    }

    ngOnDestroy() {
        console.log(' In Component Destroy ');
    }
}
